"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _formToObject = _interopRequireDefault(require("form-to-object"));

var _formUrlencoded = _interopRequireDefault(require("form-urlencoded"));

var _helpers = require("utils/helpers");

var ProductNotifyme = /*#__PURE__*/function () {
  function ProductNotifyme(component) {
    (0, _classCallCheck2["default"])(this, ProductNotifyme);
    this.dom = {
      $window: window,
      $component: component,
      $productSwitcher: document.querySelector('.js-productForm-productSwitcher'),
      $submitButton: document.querySelector('.js-productForm-submit'),
      $notifyButtons: Array.from(document.querySelectorAll('.js-product-notifyme-button'))
    }, this.state = {
      isShitBrowser: (0, _helpers.isOldIE)()
    };
    this.notifymeHandler = this.notifyme.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(ProductNotifyme, [{
    key: "mount",
    value: function mount() {
      var dom = this.dom,
          state = this.state;
      var self = this;
      console.log('ProductNotifyme : mount', this);

      if (dom.$component) {
        dom.$component.addEventListener('submit', this.notifymeHandler);
        dom.$notifyButtons.forEach(function ($button) {
          return $button.addEventListener('click', function (event) {
            return self.submitNotify(event);
          });
        });
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var dom = this.dom,
          state = this.state;
      var self = this;
      console.log('ProductNotifyme : unmount', this);

      if (dom.$form) {
        dom.$component.removeEventListener('submit', this.notifymeHandler);
        dom.$notifyButtons.forEach(function ($button) {
          return $button.removeEventListener('click', function (event) {
            return self.submitNotify(event);
          });
        });
      }
    }
  }, {
    key: "submitNotify",
    value: function submitNotify(event) {
      var dom = this.dom,
          state = this.state;
      var self = this;
      console.log('ProductNotifyme : submitNotify');
      event.preventDefault();
      event.stopPropagation();
      self.notifyme();
    }
  }, {
    key: "notifyme",
    value: function notifyme(event) {
      var dom = this.dom,
          state = this.state;
      console.log('ProductNotifyme : notifyme');

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      var data = (0, _formToObject["default"])(dom.$component);

      if (!data.variant) {
        if (dom.$productSwitcher) {
          dom.$productSwitcher.classList.add('ProductDetails__switcher--error');
          dom.$submitButton.value = dom.$submitButton.dataset.error;

          if (dom.$window.innerWidth < 1024) {
            var rect = dom.$productSwitcher.getBoundingClientRect();
            dom.$window.scrollTo({
              top: rect.top + dom.$window.scrollY - 20,
              left: 0,
              behavior: 'smooth'
            });
          }
        }

        return false;
      }

      if (!data.email) {
        if (dom.$productSwitcher) {
          dom.$component.classList.add('ProductNotifyme--error');
          dom.$submitButton.value = dom.$submitButton.dataset.error;

          if (dom.$window.innerWidth < 1024) {
            var rect = dom.$component.getBoundingClientRect();
            dom.$window.scrollTo({
              top: rect.top + dom.$window.scrollY - 20,
              left: 0,
              behavior: 'smooth'
            });
          }
        }

        return false;
      }

      if (dom.$notifyButtons) {
        dom.$notifyButtons.forEach(function ($button) {
          $button.setAttribute("disabled", "disabled");
        });
      }

      dom.$component.classList.remove('ProductNotifyme--error');
      (0, _axios["default"])({
        method: 'post',
        url: dom.$component.action,
        withCredentials: false,
        data: (0, _formUrlencoded["default"])(data)
      }).then(function (response) {
        if (response.data && response.data.success) {
          dom.$component.reset();

          if (dom.$notifyButtons) {
            dom.$notifyButtons.forEach(function ($button) {
              $button.removeAttribute("disabled");
            });
          }

          setTimeout(function () {
            if (dom.$notifyButtons) {
              dom.$notifyButtons.forEach(function ($button) {
                $button.value = $button.dataset.value;
              });
            }
          }, 2000);

          if (dom.$notifyButtons) {
            dom.$notifyButtons.forEach(function ($button) {
              $button.value = $button.dataset.success;
            });
          }
        } else {
          dom.$component.classList.add('ProductNotifyme--error');

          if (dom.$notifyButtons) {
            dom.$notifyButtons.forEach(function ($button) {
              $button.removeAttribute("disabled");
            });
          }
        }
      })["catch"](function (response) {
        console.log(response);
        dom.$component.classList.add('ProductNotifyme--error');

        if (dom.$notifyButtons) {
          dom.$notifyButtons.forEach(function ($button) {
            $button.removeAttribute("disabled");
          });
        }
      });
    }
  }]);
  return ProductNotifyme;
}();

exports["default"] = ProductNotifyme;